//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BetweenLocationsData.js";
import "../no/SelectObjectList.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"AlongPathAngle",0,"Expression",0],[0,"Associative",1,0],[1,"BetweenLocations",0,"GeometricUtilities.BetweenLocationsData",0],[0,"CopyThreads",1,0],[0,"CsysMirrorOption",1,0],[0,"FillPathLength",1,0],[1,"GeometryToInstance",0,"SelectObjectList",0],[0,"HideOriginal",1,0],[0,"MirrorPlane",1,"Plane",0],[1,"NumberOfCopies",0,"Expression",0],[1,"OnPathDistance",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"Path",1,"Section",0],[1,"RotateAngle",0,"Expression",0],[1,"RotateDistance",0,"Expression",0],[0,"RotationAxis",1,"Axis",0],[1,"TranslateDistance",0,"Expression",0],[0,"TranslationVector",1,"Direction",0],[0,"Type",1,0]],[],[]];
SPLM.Features.GeomcopyBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.GeomcopyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.GeomcopyBuilder.TransformTypes = Object.freeze({
    "BetweenLocations" : "BetweenLocations", "Mirror" : "Mirror", "Translation" : "Translation", "Rotation" : "Rotation", "AlongCurve" : "AlongCurve", "Offset" : "Offset"});

SPLM.Features.GeomcopyBuilder.AlongPathDistanceOptions = Object.freeze({
    "FillPathLength" : "FillPathLength", "ArcLength" : "ArcLength"});

SPLM.Features.GeomcopyBuilder.CsysMirrorOptions = Object.freeze({
    "MirrorXAndY" : "MirrorXAndY", "MirrorYAndZ" : "MirrorYAndZ", "MirrorZAndX" : "MirrorZAndX"});

export default SPLM;